export const variantKey = (gender, size, color) =>
  color === undefined ? `${gender}-${size}` : `${gender}-${size}-${color}`;

// Combinaciones sexo × talla para la tabla de inventario por variante
export const buildVariants = (genders = [], sizes = []) =>
  genders.flatMap((gender) =>
    sizes.map((size) => ({ key: variantKey(gender, size), gender, size }))
  );

export const getStockStatus = (stock, lowThreshold) => {
  if (stock <= 0) return { color: "error", text: "Agotado" };
  if (stock <= lowThreshold) return { color: "warning", text: "Bajo stock" };
  return { color: "success", text: "Disponible" };
};

// Del estado del formulario (mapa clave->cantidad) al arreglo plano que espera el backend
export const inventoryToVariants = (inventory, genders = [], sizes = [], colors = []) => {
  const variants = [];
  genders.forEach((gender) => {
    sizes.forEach((size) => {
      colors.forEach((color) => {
        variants.push({
          gender,
          size,
          color,
          stock: inventory[variantKey(gender, size, color)] || 0,
        });
      });
    });
  });
  return variants;
};

// Del arreglo de variantes que devuelve el backend al mapa clave->cantidad del formulario
export const variantsToInventory = (variants = []) =>
  variants.reduce((acc, v) => {
    acc[variantKey(v.gender, v.size, v.color)] = v.stock;
    return acc;
  }, {});
